import { Tranche } from 'src/app/model/tranche.model';
import { Component, Injector, Input, OnInit } from "@angular/core";
import { BaseEntityComponent, EntityOrderedRequestParameters, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { NaturezaJuridica } from "src/app/model/natureza-juridica.model";
import Utils from "src/app/shared/fgi-utils";
import { NaturezasJuridicasAceitasService } from "../../naturezas-juridicas-aceitas.service";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { ViewChild, TemplateRef } from '@angular/core';
import { Dominio } from 'src/app/model/dominio-operacao.model';
import { ActivatedRoute } from '@angular/router';
import { NaturezasJuridicasAceitasPesquisaComponent } from "../../pesquisa/naturezas-juridicas-aceitas-pesquisa.component"


@Component({
    selector: 'app-credito-livre-listagem',
    templateUrl: './credito-livre-listagem.component.html',
    styleUrls: ['./credito-livre-listagem.component.scss'],
    standalone: false
})
export class CreditoLivreListagemComponent extends BaseEntityComponent<NaturezaJuridica> implements OnInit {

  @Input() public creditoLivre: NaturezaJuridica[] = [];
  @Input() public ideTranche: string;
  @Input() public permissaoGestorEnvio: boolean;
  public atributosOrdenacao: EntityOrderedRequestParameters;
  @ViewChild('botoes') botoesPersonalizados: TemplateRef<any>;
  @ViewChild('body') msgPersonalizada: TemplateRef<any>;

  public idNatureza: number;
  public idRestricao: string;
  public dadosDominio: Dominio;


  // override
  constructor(
    protected injector: Injector,
    protected creditoLivreService: NaturezasJuridicasAceitasService,
    private modalService: BnModalMessageService,
    private activatedRoute: ActivatedRoute,
    private NaturezasJuridicasAceitasPesquisaComponent: NaturezasJuridicasAceitasPesquisaComponent



  ) {
    super(creditoLivreService);
    this.config.bloquearTelaAoRecuperarModelo = true;
    this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  //Ordenação
  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.creditoLivre = this.creditoLivre.sort((a, b) => {
      if (ord.sentido == "asc") {
        return Utils.compara(a, b, ord.atributo);
      }
      else {
        return -1 * Utils.compara(a, b, ord.atributo);
      }
    });
  }

  public excluiCreditoLivre(ideNatureza: number) {
    this.creditoLivreService.excluirCreditoLivre(this.ideTranche, ideNatureza).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Natureza de crédito livre excluída com sucesso'
      });
      this.NaturezasJuridicasAceitasPesquisaComponent.buscarTodosCreditoLivre();
    })
  }
  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true && hasMsgTemplate === true) {
      this.modalService.abrir('Inclusão de natureza de crédito livre', msg, tamanho, this.msgPersonalizada, this.botoesPersonalizados);
    }
  }

  close() {
    this.modalService.close();
  }

  dismiss() {
    this.modalService.dismiss();
  }

  public salvar() {
    let dto = new NaturezaJuridica();

    if (this.idNatureza) {
      dto.id = this.idNatureza;
    }
    if (this.idRestricao) {
      dto.restricaoTipoPessoa = this.idRestricao;
    }
    this.creditoLivreService.incluirCreditoLivre(this.ideTranche, dto).subscribe(() => {
      this.messageService.addMessage({
        title: 'Sucesso',
        type: 'CRUD_OPERATION',
        level: messageLevel.SUCCESS,
        message: 'Natureza de crédito livre incluído com Sucesso.'
      });
      this.idNatureza = null;
      this.idRestricao = null;
      this.close();
      this.NaturezasJuridicasAceitasPesquisaComponent.buscarTodosCreditoLivre();
    })
  }

}


